import React from "react";
import EmployeeTable from "../../components/micheal/EmployeeTable";
import { motion } from "framer-motion";
import { Row, Col, Button } from "react-bootstrap";

// Icons (IMPORTANT: pass as component, not JSX)
import {
  FaCalendarCheck,
  FaUmbrellaBeach,
  FaClock,
  FaUserClock,
} from "react-icons/fa";

import ReportCard from "../../components/micheal/ReportCard";
import ReportLineChart from "../../components/micheal/ReportLineChart";

function AttendanceReport() {
  const stats = [
    {
      title: "Total Working Days",
      value: 25,
      progress: 60,
      icon: FaCalendarCheck,
      color: "#28a745",
    },
    {
      title: "Total Leave Taken",
      value: 12,
      progress: 40,
      icon: FaUserClock,
      color: "#ffc107",
    },
    {
      title: "Total Holidays",
      value: 6,
      progress: 20,
      icon: FaUmbrellaBeach,
      color: "#dc3545",
    },
    {
      title: "Total Half Days",
      value: 5,
      progress: 25,
      icon: FaClock,
      color: "#0d6efd",
    },
  ];

  const chartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Present",
        data: [20, 30, 40, 50, 60, 70],
        borderColor: "#28a745",
        tension: 0.4,
      },
      {
        label: "Absent",
        data: [10, 15, 20, 25, 30, 35],
        borderColor: "#dc3545",
        tension: 0.4,
      },
    ],
  };

  const employees = [
    {
      name: "Antony Lewis",
      date: "14 Jan 2024",
      CheckIn: "9:30 AM",
      CheckOut: "6:30 PM",
      Break: "30 min",
      Late: "32 min",
      Overtime: "20 min",
      status: "Present",
    },
    {
      name: "John Doe",
      date: "14 Jan 2024",
      CheckIn: "9:00 AM",
      CheckOut: "6:00 PM",
      Break: "45 min",
      Late: "0min",
      Overtime: "10 min",
      status: "Present",
    },
    {
      name: "Sara Smith",
      date: "14 Jan 2024",
      CheckIn: "10:00 AM",
      CheckOut: "5:30 PM",
      Break: "20 min",
      Late: "1 hr",
      Overtime: "0 min",
      status: "Absent",
    },
  ];

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4 className="mb-0">Attendance Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} animate={true} />
        </Col>

        <Col md={6}>
          <ReportLineChart chartData={chartData} />
        </Col>
      </motion.div>

      {/* TABLE */}
      <EmployeeTable employees={employees} />
    </div>
  );
}

export default AttendanceReport;